<template lang="pug">
  .card
    .card-body
      h4.card-title.text-center.d-flex.justify-content-between
        i.fa.fa-chevron-left(@click.prevent="prev()")
        span Other Products and Services
        i.fa.fa-chevron-right(@click.prevent="next()")
      hr
      .row
        .col-md-8
          ValidationObserver(ref="Validation" slim)
            ValidationProvider(name="membership package" rules="required" v-slot="{errors}" slim :customMessages="{required: 'Please select at least 1 package.'}")
              .form-group
                label Please click product included on your Membership Package
              .custom-control.custom-checkbox(v-for="(value, name, index) in productAndServices", :key="'products-services-'+index")
                input.custom-control-input(:id="'produc_and_services_'+index", type="checkbox", name="produc_and_services", :value="name" v-model="packagesField")
                label.custom-control-label(:class="{'text-danger': errors.length>0}", :for="'produc_and_services_'+index") {{value}}
              small.d-block.text-danger(v-if="errors.length") {{ errors[0] }}
              //- .custom-control.custom-checkbox
                input.custom-control-input#produc_and_services2(type="checkbox" name="produc_and_services" value="KAYA_PAYMENT_PLATFORM")
                label.custom-control-label(for="produc_and_services2") KAYA PAYMENT PLATFORM
              //- .custom-control.custom-checkbox
                input.custom-control-input#produc_and_services2(type="checkbox" name="produc_and_services" value="KAYA_PAYMENT_PLATFORM")
                label.custom-control-label(for="produc_and_services2") MMC_MOBILE_APPLICATION
</template>

<style scoped=""></style>

<script>
  import { ref, reactive, watch } from '@vue/composition-api'
  
  export default {
    name: 'step_4',
    props: {
      value: {
        type: Array,
        require: true
      }
    },
    emits: ['prev', 'next'],

    setup(props, {emit}) {
      const packagesField = ref(props.value)
      const Validation = ref(null)
      const productAndServices = reactive({
        'PINOY_KOOP_ATM_SERVICE': 'PINOY KOOP ATM SERVICE',
        'KAYA_PAYMENT_PLATFORM': 'KAYA PAYMENT PLATFORM',
        'MMC_MOBILE_APPLICATION': 'MMC MOBILE APPLICATION',
        'INSURANCE_(AKSI,GLAFFLETC)': 'INSURANCE (AKSI,GLAFFLETC)',
      })
      watch(() => props.value, (newVal, prevVal) => {
        packagesField.value = newVal;
      })
      const prev = () => {
        emit('prev');
      }
      const next = () => {
        emit('next');
      }
      const validate = () => {
        emit('input', packagesField.value)
        return Validation.value.validate()
          .then(success => {
            if(success) {
              return Promise.resolve(success)
            }
            return Promise.reject(success)
          })
      }
      return {
        productAndServices,
        Validation, prev, next,
        packagesField, validate
      }
    }
  }
</script>